export const DEFAULT_ENV_KEY = '_llpweautdefaultenv'
